import { createAction } from 'redux-actions';
import { PapiStudioEarningsInit } from '@wix/da-papi-types';

export interface Fee {
  flat: string;
  relative: string;
}

export const initializeEarnings = createAction(
  'STUDIO.EARNINGS_INITIALIZE',
  (
    earningsData: Omit<
      PapiStudioEarningsInit,
      'session' | 'max_capacity' | 'free_capacity' | 'bookmarks' | 'transactions'
    >
  ) => ({ earningsData })
);

export const fetchTransactions = createAction(
  'FETCH_TRANSACTIONS',
  (streamId: string, limit: number, offset: number) => ({
    streamId,
    limit,
    offset,
  })
);

export const updatePaypalState = createAction(
  'STUDIO.EARNINGS_UPDATE_PAYPAL_STATE',
  (payload: { email: string; isMissingCountry: boolean; fee?: Fee }) => payload
);

export const updateBitpayState = createAction(
  'STUDIO.EARNINGS_UPDATE_BITPAY_STATE',
  (payload: { email: string; fee?: Fee }) => payload
);

export const updateStripeState = createAction(
  'STUDIO.EARNINGS_UPDATE_STRIPE_STATE',
  (payload: { fee?: Fee }) => payload
);
